import { render, staticRenderFns } from "./MobileCategoryTabs.vue?vue&type=template&id=91de96d4&scoped=true"
import script from "./MobileCategoryTabs.vue?vue&type=script&lang=js"
export * from "./MobileCategoryTabs.vue?vue&type=script&lang=js"
import style0 from "./MobileCategoryTabs.vue?vue&type=style&index=0&id=91de96d4&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91de96d4",
  null
  
)

export default component.exports